goog.provide("shadow.js.shim.module$zustand");
goog.provide("module$shadow_js_shim_module$zustand");
shadow.js.shim.module$zustand = shadow.js.nativeProvides["zustand"] = shadow$bridge("zustand");
module$shadow_js_shim_module$zustand.default = shadow.js.shim.module$zustand;
